/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Components.Common {
    "use strict";

    export interface ILotAllocationRow {
        variantLotId: string;
        variantLot?: any;
        quantity: number;
        lastQuantity?: number;
    }

    export class LotAllocationUtil {
        static syncSelectedId(lot: ILotAllocationRow): void {
            lot.variantLotId = lot && lot.variantLot ? lot.variantLot.variantLot_TId : null;
        }

        static buildCriteria(variantId: string, productInventoryType: any): any {
            return { variant_TId: variantId, productInventoryType: productInventoryType };
        }

        static qtyTotal(allocations: ILotAllocationRow[]): number {
            return _.reduce(allocations || [], (sum: number, l: any) => sum + (+l.quantity || 0), 0);
        }

        static qtyTotalForSelected(allocations: ILotAllocationRow[]): number {
            return _.reduce(allocations || [], (sum: number, l: any) => sum + (l.variantLotId ? (+l.quantity || 0) : 0), 0);
        }

        static isQtyMismatch(allocations: ILotAllocationRow[], targetQty: number): boolean {
            return LotAllocationUtil.qtyTotal(allocations) !== (+targetQty || 0);
        }

        static allRowsHaveLot(allocations: ILotAllocationRow[]): boolean {
            return !_.some(allocations || [], (l: any) => !l.variantLotId);
        }

        static addRow(allocations: ILotAllocationRow[]): void {
            allocations.push({ variantLotId: null, variantLot: null, quantity: 1, lastQuantity: 1 });
        }

        static removeRow(allocations: ILotAllocationRow[], index: number): void {
            if (allocations && index >= 0 && index < allocations.length) {
                allocations.splice(index, 1);
            }
        }

        static areAllocationsValid(allocations: ILotAllocationRow[], targetQty: number, requireExactQty: boolean): boolean {
            const rows = allocations || [];
            if (rows.length === 0) {
                return false;
            }
            if (!LotAllocationUtil.allRowsHaveLot(rows)) {
                return false;
            }
            return !requireExactQty || !LotAllocationUtil.isQtyMismatch(rows, targetQty);
        }

        static areAllocationsValidForQty(allocations: ILotAllocationRow[], targetQty: number): boolean {
            return LotAllocationUtil.areAllocationsValid(allocations, targetQty, targetQty > 1);
        }
    }
}
